export default () => {
	(function ($) {
		if ($('.section--faq').length) {
			$('.faq-item__header').on('click', function () {
				var parent = $(this).parent();
				var content = $(this).next();

				if (parent.hasClass('faq-item--is-open')) {
					$('.faq-item').removeClass('faq-item--is-open');
					$('.faq-item__content').slideUp(200);
				} else {
					$('.faq-item').removeClass('faq-item--is-open');
					$('.faq-item__content').slideUp(200);
					parent.addClass('faq-item--is-open');
					content.slideDown(200);
				}
			});
		}
	})(jQuery);
}
